import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import {
    SEARCH_ROW_EDGE_ON_PHONE_CLASS,
    SearchResultRowVerticalContext,
} from "@/main/react/page/search/result-row/SearchResultRowBase";

export function SearchResultSkeleton(props: { showAvatar?: boolean }) {
    const { showAvatar = false } = props;
    const { edgeToEdgeOnPhone } = React.useContext(SearchResultRowVerticalContext);

    // Recipe must track SearchResultRowBase's container exactly, or the placeholder is visibly a
    // different shape from the row that replaces it.
    return (
        <div className={cn("overflow-hidden rounded-xl border border-border bg-card p-4 sm:p-5", edgeToEdgeOnPhone && SEARCH_ROW_EDGE_ON_PHONE_CLASS)}>
            <div className="flex items-start gap-4">
                {showAvatar ? <Skeleton className="size-14 rounded-full" /> : null}
                <div className="min-w-0 flex-1 space-y-3">
                    <div className="flex gap-2">
                        <Skeleton className="h-6 w-20 rounded-full" />
                        <Skeleton className="h-5 w-32 rounded-full" />
                    </div>
                    <Skeleton className="h-5 w-2/3" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-5/6" />
                </div>
            </div>
        </div>
    );
}

export default SearchResultSkeleton;
